import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { COMMON_API } from "../../commonAPI";

// Import Bootstrap + Summernote
import "bootstrap/dist/css/bootstrap.min.css";
import "summernote/dist/summernote-lite.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import $ from "jquery";
import "summernote/dist/summernote-lite.js";

const EditTermsCondition = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = sessionStorage.getItem("authToken");

  const [description, setDescription] = useState("");
  const editorRef = useRef(null);

  // Fetch TermsCondition from API
  const fetchTermsCondition = async () => {
    try {
      const res = await axios.get(`${COMMON_API}/loan/getSingleTermsCondition/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.success) {
        setDescription(res.data.data.description);
        $(editorRef.current).summernote("code", res.data.data.description);
      }
    } catch (err) {
      console.error("Error fetching TermsCondition:", err);
    }
  };

  useEffect(() => {
    // Initialize Summernote
    $(editorRef.current).summernote({
      height: 250,
      toolbar: [
        ["style", ["style"]],
        ["font", ["bold", "italic", "underline", "clear"]],
        ["fontname", ["fontname"]],
        ["color", ["color"]],
        ["para", ["ul", "ol", "paragraph"]],
        ["insert", ["link", "picture", "video"]],
        ["view", ["fullscreen", "codeview", "help"]],
      ],
      callbacks: {
        onChange: function (contents) {
          setDescription(contents);
        },
      },
    });

    fetchTermsCondition();

    // Cleanup on unmount
    return () => {
      $(editorRef.current).summernote("destroy");
    };
    // eslint-disable-next-line
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.put(
        `${COMMON_API}/loan/editTermsCondition/${id}`,
        { description },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data.success) {
        alert("TermsCondition updated successfully!");
        navigate("/terms-condition");
      }
    } catch (err) {
      console.error("Error updating TermsCondition:", err);
      alert("Failed to update Terms Condition.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-2xl p-6">
        <h2 className="text-2xl font-bold mb-4">Edit TermsCondition</h2>
        <form onSubmit={handleSubmit}>
          {/* Summernote Editor */}
          <textarea ref={editorRef} defaultValue={description}></textarea>

          <button
            type="submit"
            className="mt-4 btn btn-primary"
          >
            Update
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditTermsCondition;
